<template>
  <crm-menu :links="links">
    <router-view></router-view>
  </crm-menu>
</template>

<script>
import { mapGetters } from "vuex";
import CrmMenu from "./CRMMenu";

export default {
  components: {
    CrmMenu
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    links() {
      let links = [
        { name: "My Day", path: `/crm` },
        { name: "Quick Log", path: `/crm/log` },
        { name: "Contacts", path: `/crm/contacts` },
        { name: "Activity", path: `/crm/activity` }
      ];
      if (this.isAdmin) {
        links.push({ name: "Team", path: `/crm/team` });
      }
      return links;
    }
  }
};
</script>

<style scoped lang="scss"></style>
